<div class='center'>
    <h1>Menu</h1>
    <button routerLink="/players" class="btn">Equipe</button>
    <button routerLink="/clubs" class="btn">Clubs</button>
    <button routerLink="/login" class="btn">Connexion</button>
</div>

<router-outlet></router-outlet>